import L from 'lodash';
import {
  post,
  get,
  put,
  patch,
  removeWithModel,
  getWithQueryString,
} from './api';
import { state } from 'react-beep';

export default {
  transactions: {
    getList: async () => {
      return await get({
        api: '/user/transactions',
      });
    },
  },

  place: {
    inspection_states: async () => {
      const id = L.get(state, 'insInfo.installmentData.id');
      return await get({
        api: `/place/inspection_states${
          id ? `?insurance_company_id=${id}` : ''
        }`,
      });
    },
    inspection_cities: async (state_id) => {
      const id = L.get(state, 'insInfo.installmentData.id');
      return await get({
        api: `/place/inspection_cities?state_id=${state_id}${
          id ? `&insurance_company_id=${id}` : ''
        }`,
      });
    },
    state: async () => {
      return await get({
        api: '/place/state',
      });
    },
    city: async (model) => {
      return await post({
        api: '/place/city',
        model,
      });
    },
  },

  vehicle: {
    carbrand: async () => {
      return await get({
        api: '/vehicle/carbrand',
      });
    },
    carmodel: async (model) => {
      return await post({
        api: '/vehicle/carmodel',
        model,
      });
    },
    middletruckbrand: async () => {
      return await get({
        api: '/vehicle/middletruckbrand',
      });
    },
    middletruckmodel: async (model) => {
      return await post({
        api: '/vehicle/middletruckmodel',
        model,
      });
    },
    motorType: async () => {
      return await get({
        api: '/vehicle/motor_type',
      });
    },
  },
  insurance: {
    insuranceCompany: async (model = { user_type: 'normal' }) => {
      return await getWithQueryString({
        api: '/insurance/insurancecompany',
        model,
      });
    },
    selectCompany: async (model) => {
      return await post({
        api: '/insurance/selectedinsurancecompany',
        model,
      });
    },
    typeInsurance: async (model) => {
      return await get({
        api: '/insurance/insurancetype',
        model,
      });
    },
    financialObligation: async () => {
      return await get({
        api: '/get_financial_obligations',
      });
    },
  },
  reminder: {
    getList: async () => {
      return await get({
        api: '/reminder/reminder',
      });
    },
    postReminder: async (model) => {
      return await post({
        api: '/reminder/reminder',
        model,
      });
    },
    editReminder: async (model) => {
      return await put({
        api: '/reminder/reminder',
        model,
      });
    },
    deleteReminder: async (id) => {
      return await removeWithModel({
        api: `/reminder/reminder`,
        model: { id: id },
      });
    },
  },
  user: {
    getInsuranceDetailsById: async (id) => {
      return await post({
        api: '/user/insurancelist',
        model: { shopping_basket: id },
      });
    },
    get_basket_id: async (model) => {
      return await post({
        api: '/user/get_basket_id',
        model,
      });
    },
    naft_send_sms: async (model) => {
      return await post({
        api: '/naft/send_sms',
        model,
      });
    },
    send_sms: async (model) => {
      return await post({
        api: '/user/send_sms',
        model,
      });
    },
    login: async (model) => {
      return await post({
        api: '/user/login/',
        model,
      });
    },
    logout: async (model) => {
      return await get({
        api: '/user/logout',
        model,
      });
    },
    getProfile: async () => {
      return await get({
        api: '/user/profile',
      });
    },
    profile: async (model) => {
      return await post({
        api: '/user/profile',
        model,
      });
    },
    editProfile: async (model) => {
      return await put({
        api: '/user/profile',
        model,
      });
    },
    changeNumber: async () => {
      return await get({
        api: '/user/change_number',
      });
    },
    EditChangeNumber: async (model) => {
      return await put({
        api: '/user/change_number',
        model,
      });
    },
    insurancelist: async () => {
      return await get({
        api: '/user/insurancelist',
      });
    },
    telephone: async (model) => {
      return await post({
        api: '/user/telephone',
        model,
      });
    },
    khabarname: async (model) => {
      return await post({
        api: '/user/khabarname',
        model,
      });
    },
    poshtibani: async (model) => {
      return await post({
        api: '/user/poshtibani',
        model,
      });
    },
  },

  basket: {
    thirdParty: async (model) => {
      if (model.PercentOfDiscountForDriverDamage === 'NoN') {
        model.PercentOfDiscountForDriverDamage = '0';
      }
      if (model.PercentOfDiscountForThird === 'NoN') {
        model.PercentOfDiscountForThird = '0';
      }
      return await post({
        api: '/thirdparty_price',
        model,
      });
    },
    detailSelect: async (model) => {
      if (state.carInfo.code) {
        model.input_discount = state.carInfo.code;
      }
      if (String(model.VehicleType) === '23') {
        model.VehicleType = '1';
      }
      if (String(model.VehicleType) === '2') {
        model.truck_brand = model.car_brand;
        model.truck_model = model.car_model;
        delete model.car_brand;
        delete model.car_model;
      }
      if (!model.OutOrIn_taxi) {
        model.OutOrIn_taxi = '0';
      }
      if (model.motor_type) {
        model.VehicleType = '3';
      }
      return await post({
        api: '/basket/details_for_selected_insurance',
        model,
      });
    },
    editdetailSelect: async (model) => {
      return await patch({
        api: '/basket/details_for_selected_insurance',
        model,
      });
    },
    shopping: async (model) => {
      return await post({
        api: '/basket/shopping_basket',
        model,
      });
    },
    editShopping: async (model) => {
      return await patch({
        api: '/basket/shopping_basket',
        model,
      });
    },
    completeInsurance: async (model) => {
      return await post({
        api: '/basket/complete_insurance_info',
        model,
      });
    },
    postAddress: async (model) => {
      return await post({
        api: '/basket/post_address',
        model,
      });
    },
    updatePostAddress: async (model) => {
      return await patch({
        api: '/basket/post_address',
        model,
      });
    },
    delivery: async (model) => {
      return await post({
        api: '/basket/delivery_time',
        model,
      });
    },
    changeDelivery: async (model) => {
      return await patch({
        api: '/basket/delivery_time',
        model,
      });
    },
    address: async (model) => {
      return await post({
        api: '/basket/insert_address',
        model,
      });
    },
    editAddress: async (model) => {
      return await patch({
        api: '/basket/insert_address',
        model,
      });
    },
    inspection_address: async (model) => {
      return await post({
        api: '/basket/inspection_address',
        model,
      });
    },
    //body
    bodyPrice: async (model) => {
      return await post({
        api: '/basket/body_price',
        model,
      });
    },
    editBodyPrice: async (model) => {
      return await patch({
        api: '/basket/body_price',
        model,
      });
    },

    buy: async (model) => {
      return await post({
        api: '/buy-new-zarinpal',
        model,
      });
    },

    checkVoucher: async (model) => {
      return await post({
        api: '/basket/input_discount',
        model,
      });
    },
  },

  error: {
    getError: async () => {
      return await get({
        api: '/error/e_insert_address',
      });
    },
  },
  config: {
    getHeader: async () => {
      return await get({
        api: '/price_in_header',
      });
    },
    discountsText: async () => {
      return await get({
        api: '/discounts_text',
      });
    },
  },
  naft: {
    getUserData: async (model) => {
      return await getWithQueryString({
        api: '/naft/signup',
        model,
      });
    },

    naftLogin: async (model) => {
      return await post({
        api: '/naft/login',
        model,
      });
    },
  },
  fire: {
    postFireInsurance: async (model) => {
      return await post({
        api: '/fire',
        model,
      });
    },
  },
  earthquake: {
    postEarthquakeInsurance: async (model) => {
      return await post({
        api: '/earthquake',
        model,
      });
    },
  },
  building: {
    getBuildingType: async () => {
      return await get({
        api: '/building-types',
      });
    },
    shopping: async (model) => {
      return await post({
        api: '/basket/details_for_selected_insurance',
        model,
      });
    },
  },
  cure: {
    getBaseInsurace: async () => {
      return await get({
        api: '/base_insurance',
      });
    },
    postPersonalCure: async (model) => {
      return await post({
        api: '/personal_price',
        model,
      });
    },
    postPersonalDetails: async (model) => {
      return await post({
        api: '/personal_details',
        model,
      });
    },
    getPersonalCover: async () => {
      return await get({
        api: '/personal_cover',
      });
    },
    postCompanyCure: async (model) => {
      return await post({
        api: '/company_cure_price',
        model,
      });
    },
    shopping: async (model) => {
      return await post({
        api: '/basket/details_for_selected_insurance',
        model,
      });
    },
  },
  responsibility: {
    postResponsibilityPrice: async (model) => {
      return await post({
        api: '/res/responsibility_price/',
        model,
      });
    },
    getMedicTypes: async () => {
      return await get({
        api: '/res/medic_types',
      });
    },
    getDoctorCovers: async () => {
      return await get({
        api: '/res/responsibility_cover',
      });
    },
    postArea: async (model) => {
      return await post({
        api: '/res/areas/',
        model,
      });
    },
    postNoAccident: async (model) => {
      return await post({
        api: '/res/no_accident/',
        model,
      });
    },
    shopping: async (model) => {
      return await post({
        api: '/basket/details_for_selected_insurance',
        model,
      });
    },
  },
  life: {
    getContractPayment: async () => {
      return await get({
        api: '/contract_payment',
      });
    },
    postLifePrice: async (model) => {
      return await post({
        api: '/life',
        model,
      });
    },
  },
  organization: {
    postOrganizationPrice: async (model) => {
      return await post({
        api: '/organization-order/',
        model,
      });
    },
  },
  // profile
  profile: {
    postInstallmentPayment: async (model) => {
      return await post({
        api: `/installment-payment/${model.id}/`,
        model,
      });
    },
  },
  travel: {
    postTravelPrice: async (model) => {
      return await post({
        api: '/travel/travels/',
        model,
      });
    },
    getContriesList: async () => {
      return await get({
        api: '/travel/countries/',
      });
    },
    getDamagePaidList: async () => {
      return await get({
        api: '/travel/damage-paid/',
      });
    },
    getPassengerAgeList: async () => {
      return await get({
        api: '/travel/passenger-age/',
      });
    },
    getDurationList: async () => {
      return await get({
        api: '/travel/durations/',
      });
    },
    shopping: async (model) => {
      return await post({
        api: '/basket/details_for_selected_insurance',
        model,
      });
    },
    passengerDetails: async (model) => {
      return await post({
        api: '/basket/travel_details',
        model,
      });
    },
  },
};
